import $ from 'jquery';
import { getDevicetype} from "../Utils/Helper";
export var surveyapi = {
    survey(data,url) {
        // data.append("deviceid", localStorage.getItem('_userdevice') || null);
        data.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");        
        data.append("apiversion", "2");
        data.append("platform", getDevicetype());
        data.append("request_source", "pwa");
        var settings = {
            "async": true,
            "url": url,
            "method": "POST",
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": data,
            error: function (xhr, textStatus, errorThrown) {

            }
        }
        var request = $.ajax(settings)
        return request;
    }
} 

